import { pathOr } from "ramda";
export var selectNonCloudFiles = function selectNonCloudFiles(store) {
    return pathOr([], ["FileTreeReducer", "nonCloudFiles"], store);
};
